/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DictionaryVm,
    DictionaryVmFromJSON,
    DictionaryVmFromJSONTyped,
    DictionaryVmToJSON,
} from './';

/**
 * 
 * @export
 * @interface DictionaryVmPaginatedSearchResponse
 */
export interface DictionaryVmPaginatedSearchResponse {
    /**
     * 
     * @type {Array<DictionaryVm>}
     * @memberof DictionaryVmPaginatedSearchResponse
     */
    items?: Array<DictionaryVm> | null;
    /**
     * 
     * @type {number}
     * @memberof DictionaryVmPaginatedSearchResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof DictionaryVmPaginatedSearchResponse
     */
    from?: number;
    /**
     * 
     * @type {number}
     * @memberof DictionaryVmPaginatedSearchResponse
     */
    to?: number;
    /**
     * 
     * @type {number}
     * @memberof DictionaryVmPaginatedSearchResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof DictionaryVmPaginatedSearchResponse
     */
    size?: number;
}

export function DictionaryVmPaginatedSearchResponseFromJSON(json: any): DictionaryVmPaginatedSearchResponse {
    return DictionaryVmPaginatedSearchResponseFromJSONTyped(json, false);
}

export function DictionaryVmPaginatedSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DictionaryVmPaginatedSearchResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(DictionaryVmFromJSON)),
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'from': !exists(json, 'from') ? undefined : json['from'],
        'to': !exists(json, 'to') ? undefined : json['to'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'size': !exists(json, 'size') ? undefined : json['size'],
    };
}

export function DictionaryVmPaginatedSearchResponseToJSON(value?: DictionaryVmPaginatedSearchResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(DictionaryVmToJSON)),
        'totalCount': value.totalCount,
        'from': value.from,
        'to': value.to,
        'page': value.page,
        'size': value.size,
    };
}


